module.exports = __webpack_public_path__ + "img/banner2.1afd4e2f.png";